/*
 * Design tokens carried over verbatim from prototypes/mode-a.html.
 * Values are deliberately unchanged: the prototype is the reference mockup.
 */

:root {
  /* Layout metrics — SCREEN ONLY.
     Print derives its own step from the page width (implementation-plan.md §5.1);
     --px-per-tick must never reach the print path. */
  --px-per-tick: 34;
  --period-lane-h: 20;
  --event-lane-h: 16;
  --band-gap: 28;
  --bar-gap: 3;
  --gutter-w: 0;

  /* Surfaces */
  --paper: #fafaf7;
  --panel: #eef0ea;

  /* Text */
  --ink: #222;
  --ink-bar: #1a1a1a;
  --ink-faint: #555;
  --ink-muted: #666;
  --ink-label: #444;

  /* Rules and strokes */
  --rule: #ccc;
  --rule-soft: #999;
  --rule-strong: #333;
  --field-border: #bbb;

  /* Actions */
  --accent: #6fa85a;
  --accent-hover: #5c8f49;
  --accent-border: #4a7a3e;
  --danger: #8b1e1e;

  /* Save-state levels (status pill). Ochre keeps the warm cast of the mockup. */
  --warn: #8a6a1c;
  --urgent: var(--danger);

  /* --- Chrome surfaces (app.css only) ------------------------------------
     Derived from the values above; the prototype's palette is unchanged.
     Nothing here reaches the chart or the print path. */
  --paper-raised: #fff;
  --surface-hover: #f0f0ec;
  --accent-soft: #edf2e8;
  --accent-ring: rgba(111, 168, 90, 0.45);
  --danger-soft: #f7ecec;
  --warn-soft: #faf4e4;

  /* The add-entry pair: the toolbar pill and the floating disc share a height,
     so they read as one action in two places. */
  --fab-size: 52px;

  --radius-control: 3px;
  --radius-panel: 4px;

  --shadow-dialog: 0 14px 40px rgba(28, 26, 20, 0.2), 0 2px 6px rgba(28, 26, 20, 0.1);
  --backdrop: rgba(34, 32, 26, 0.32);

  --mono: ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, monospace;
}
